import { CourseInstructor } from "@types";
import Image from "next/image";
import Link from "next/link";
import { FC } from "react";

interface Props {
  instructorItem: CourseInstructor;
}

const instructorAvatarPlaceholder =
  "https://faradars.org/wp-content/uploads/2024/11/11/faradars-default.svg";

const InstructorAvatar: FC<Props> = ({ instructorItem }) => {
  return (
    <Link
      href={`/instructors/${instructorItem.slug}`}
      target="_blank"
      rel="noppener noreferrer"
      className="w-fds-60 md:w-20 min-w-fds-60 md:h-20 h-fds-60 md:min-w-20 border-2 shadow-brand-md border-fds-on-inverse rounded-full relative p-0"
    >
      {instructorItem.profile_picture ? (
        <Image
          src={instructorItem.profile_picture}
          alt={`${instructorItem.first_name} ${instructorItem.last_name}`}
          fill
          className="rounded-full aspect-square "
        />
      ) : (
        <Image
          src={instructorAvatarPlaceholder}
          alt={`${instructorItem.first_name} ${instructorItem.last_name}`}
          fill
          className="aspect-square "
        />
      )}
    </Link>
  );
};

export default InstructorAvatar;
